import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { saveState, loadState, removeState } from '../../utils/browser-storage';

// Kalau punya model User, bisa import:
// import User from "../../models/user"

// Untuk sekarang, saya bikin tipe sederhana
export interface User {
  areaId?: string;
  areaName: string;
  email: string;
  id: string;
  name: string;
  note: string;
  profileImageUrl: string;
  regionId: string;
  regionName: string;
  role: string;
}

interface UserState {
  user: User | null;
}

const type = 'user';

const initialState: UserState = {
  user: loadState<User>(type) ?? null
};

export const userSlice = createSlice({
  name: type,
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      saveState(type, action.payload);
    },
    removeUser: (state) => {
      state.user = null;
      removeState(type);
    }
  }
});

// Action creators
export const { setUser, removeUser } = userSlice.actions;

export default userSlice.reducer;
